import { IconProps } from "@/src/sb/business-layer/types"
import React from "react"

const NavigateKeyboardIcon = ({ width, height, size }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? size ?? 12}
    height={height ?? size ?? 12}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1.5L2.25 5.25L2.77875 5.77875L5.625 2.93625V11.25H6.375V2.93625L9.22125 5.77875L9.75 5.25L6 1.5Z"
      fill="currentColor"
    />
  </svg>
)

export default NavigateKeyboardIcon
